module.exports = __webpack_public_path__ + "img/18600.5a1bd032.jpg";